import React from 'react';
import { useIsSignedIn } from '../Auth/Context';
import { fetchAllPermissions } from '../../utils';
import { PermissionsContext } from './Context';

export const PermissionsProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [permissions, setPermissions] = React.useState<string[]>([]);
  const [domainError, setDomainError] = React.useState<boolean>(false);
  const isSignedIn = useIsSignedIn();

  React.useEffect(() => {
    if (isSignedIn) {
      fetchAllPermissions()
        .then(setPermissions)
        .catch((error) => {
          console.error('Error fetching permissions:', error);
          if (error.message === 'DOMAIN_ACCESS_RESTRICTED') {
            setDomainError(true);
          }
        });
    }
  }, [isSignedIn]);

  // Show domain restriction message for external guides
  if (false && domainError) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
          textAlign: 'center',
          padding: '20px',
        }}
      >
        <h2 style={{ color: '#d32f2f', marginBottom: '16px' }}>Access Restricted</h2>
        <p style={{ maxWidth: '500px', lineHeight: 1.6, marginBottom: '20px' }}>
          Guides must access this service from the correct domain.
        </p>
        <p style={{ fontWeight: 'bold', color: '#1976d2' }}>
          Please visit:{' '}
          <a href="https://guide.leelalife.com" style={{ color: '#1976d2' }}>
            guide.leelalife.com
          </a>
        </p>
      </div>
    );
  }

  return <PermissionsContext.Provider value={permissions}>{children}</PermissionsContext.Provider>;
};
